import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const ValuePropositionHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData =
    labels.menuPages?.howItWorks?.valuePropositionSection?.header || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-16"
    >
      <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-white via-orange-100 to-pink-100 bg-clip-text text-transparent mb-6">
        {headerData.title || "Varför Välja BILENIA?"}
      </h2>
      <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
        {headerData.description || "Tre grundpelare som gör oss unika"}
      </p>
    </motion.div>
  );
};

export default ValuePropositionHeader;
